import React from 'react';
import FullPageLoader from '../loaders/FullPageLoader';
import AlertModal from './AlertModal';
import CustomModalForm from '../components/CustomModalForm';

const ReduxModalsIndex = () => {
    return (
        <>
           <CustomModalForm />
           <AlertModal/> 
           <FullPageLoader/>
        </>
    );
};

export default ReduxModalsIndex;